import { ReactElement, isValidElement } from "react";

import { DropdownPopOverContent } from "./content";
import { DropdownPopOverFooter } from "./footer";
import { DropdownPopOverHeader } from "./header";

export const isDropdownPopOverHeaderComp = (
  node: any
): node is ReactElement<{}, typeof DropdownPopOverHeader> =>
  isValidElement(node) && node.type === DropdownPopOverHeader;

export const isDropdownPopOverFooterComp = (
  node: any
): node is ReactElement<{}, typeof DropdownPopOverFooter> =>
  isValidElement(node) && node.type === DropdownPopOverFooter;

export const isDropdownPopOverContentComp = (
  node: any
): node is ReactElement<{}, typeof DropdownPopOverContent> =>
  isValidElement(node) && node.type === DropdownPopOverContent;
